import React, { FC } from 'react'

import { IconCameraProps } from './IconCamera.types'
import * as Styled from './styles/IconCamera.style'

import { nonThemeableRules } from '../../ruleSet'

const IconCamera: FC<IconCameraProps> = ({
  size = nonThemeableRules.defaultSize as number as IconCameraProps['size'],
  isResponsive = false,
}: IconCameraProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path d='M24 35.09a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z' stroke='#E60000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M43 19.13v15.883a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4V19.13a4 4 0 0 1 4-4h3.825c.367.004.731-.063 1.073-.198a3.402 3.402 0 0 0 1.162-.832l2.48-3.57a3.282 3.282 0 0 1 2.655-1.44h7.517a3.297 3.297 0 0 1 2.788 1.468l2.45 3.572c.657.63 1.528.987 2.438 1H39a4 4 0 0 1 4 4Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconCamera
